import type { HistogramChartTooltipProps } from '../types/histogram-props.js';

export const Tooltip = (props: HistogramChartTooltipProps) => null;

Tooltip['displayName'] = 'HistogramChart.Tooltip';
